import { createAction } from '@reduxjs/toolkit'

import { INIT_EXTENDED_PARTNER_DATA_ACTION } from '../configs'

/** Initialize partner dashboard - ./listeners/initEPDataListener */
export const initEPDataAction = createAction(
  INIT_EXTENDED_PARTNER_DATA_ACTION,
  (partnerId: string, callback?: () => void) => {
    return {
      payload: { partnerId, callback },
    }
  }
)
